import { useEffect, useState } from "react";
/* Styles */
import "./toggleSwitch.css";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import useSnackbarStore from "../../../store/snackbarStore";

const ToggleSwitch = ({ name, onChange, value }) => {
  const [toggle, setToggle] = useState(true);
  const location = useLocation();
  const { show } = useSnackbarStore();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("sessionId");
  const toggleClass = "toggle-active";
  const onToogle = () => {
    if (sessionId) {
      show(
        "Si deseas cambiar el idioma, debes volver a iniciar con este superpoder",
        "important"
      );
    } else {
      onChange(!toggle);
      setToggle(!toggle);
    }
  };

  useEffect(() => {
    const localLang = localStorage.getItem("lang");
    if (localLang) {
      setToggle(localLang === "en");
    } else {
      setToggle(false);
    }
  }, []);

  return (
    <div
      className={classNames("toggle-switch", {
        eng: toggle,
        esp: !toggle,
        "cursor-not-allowed": sessionId,
        "cursor-pointer": !sessionId,
      })}
      onClick={onToogle}
    >
      <div className={`toggle-inner ${toggle ? null : toggleClass}`}></div>
    </div>
  );
};

export default ToggleSwitch;
